import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Ruma Palace</h3>
            <p>
              Your comfortable stay in Ujjain. Experience modern amenities and 
              excellent hospitality in the heart of the city.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a></li>
              <li><a href="#rooms" onClick={(e) => { e.preventDefault(); scrollToSection('rooms'); }}>Rooms</a></li>
              <li><a href="#amenities" onClick={(e) => { e.preventDefault(); scrollToSection('amenities'); }}>Amenities</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>📍 <a href="https://maps.app.goo.gl/vjLyugHNAfam4pfD7" target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>Ujjain, Madhya Pradesh</a></li>
              <li>📞 <a href="tel:+919039997993" style={{color: 'inherit'}}>+91 90399 97993</a> (Kuldeep)</li>
              <li>📞 <a href="tel:+917440361016" style={{color: 'inherit'}}>+91 74403 61016</a> (Aditya)</li>
              <li>✉️ <a href="mailto:palaceruma@gmail.com" style={{color: 'inherit'}}>palaceruma@gmail.com</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Newsletter</h4>
            <p>Subscribe to get special offers and updates</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Your Email" />
              <button type="submit" className="btn btn-primary">Subscribe</button>
            </form>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright-notice">
            <p className="copyright-title">Copyright Notice</p>
            <p>
              © {new Date().getFullYear()} Ruma Palace Hotel, Ujjain.
            </p>
            <p>
              All content on this website, including text, images, layout, and design, is the property of Ruma Palace Hotel unless otherwise stated.
            </p>
            <p>
              Unauthorized copying, reproduction, or distribution of any material from this website is strictly prohibited without prior written permission.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

